<template>
  <div class="map">
    <div class="map-wrap">
      <div class="map-content">
        <div class="map-r">
          <div class="map-header"></div>
          <div id="map_container" ref="map"></div>
          <div class="div-r">
            <div class="tabs">
              <div
                class="tab-item"
                :class="{ active: activeSection.code === item.code }"
                v-for="(item, index) in sectionList"
                @click="sectionChange(item)"
                :key="index"
              >
                {{ item.sectionName }}
              </div>
            </div>
            <div class="section-statistics">
              <div class="statistics-item">
                <div class="text">学校</div>
                <div class="nums">
                  <div class="num">{{ sectionStatistic.schoolNum || 0 }}</div>
                  <div class="unit">所</div>
                </div>
              </div>
              <div class="statistics-item">
                <div class="text">教师</div>
                <div class="nums">
                  <div class="num">{{ sectionStatistic.teacherNum || 0 }}</div>
                  <div class="unit">人</div>
                </div>
              </div>
              <div class="statistics-item">
                <div class="text">学生</div>
                <div class="nums">
                  <div class="num">{{ sectionStatistic.studentNum || 0 }}</div>
                  <div class="unit">人</div>
                </div>
              </div>
            </div>
            <div class="map-l">
              <div class="map-l-input">
                <el-input
                  placeholder="请输入要查找的学校名称"
                  suffix-icon="el-icon-search"
                  v-model="keyword"
                  @input="querySearch"
                ></el-input>
              </div>
              <div class="school-list">
                <template v-if="showSchoolList.length > 0">
                  <div
                    class="school-item"
                    v-for="item in showSchoolList"
                    :key="item.schoolId"
                    @click="handleSelect(item)"
                    :title="item.schoolName"
                  >
                    {{ item.schoolName }}
                  </div>
                </template>
                <div class="no-data" v-else>
                  <no-data></no-data>
                </div>
              </div>
            </div>
          </div>
          <div class="map-statistics" :style="computedLeftStyle">
            <div class="all-statistics">
              <div class="title">全部<br />数据统计</div>
              <div class="statistics-list">
                <div class="statistics-item">
                  <div class="nums">{{ totalStastic.schoolNum || 0 }}</div>
                  <div class="text">学校总数</div>
                </div>
                <div class="statistics-item">
                  <div class="nums">{{ totalStastic.teacherNum || 0 }}</div>
                  <div class="text">教师总数</div>
                </div>
                <div class="statistics-item">
                  <div class="nums">{{ totalStastic.studentNum || 0 }}</div>
                  <div class="text">学生总数</div>
                </div>
                <!--<div class="statistics-item">-->
                <!--<div class="nums">{{ viewNum }}</div>-->
                <!--<div class="text">访问次数 (次)</div>-->
                <!--</div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { createMap, initMap } from "../../utils/BMapGL";
import {
  schoolPage,
  statisticBySchool,
  statistic,
  count,
  insert,
  statisticByStep,
} from "../../api/gxHome/api.home";
import mapData1 from "./data";
import styleJson from "./custom_map_config.json";
import newIcon from "../../assets/images/ytHome/icon_new.png";
import clickIcon from "../../assets/images/ytHome/check-icon.png";
import noData from "../../components/common/Nodata.vue";
export default {
  data() {
    return {
      activeSection: {
        sectionName: "小学",
        code: "xxjd_xiaoxue",
      },
      sectionList: [
        {
          sectionName: "幼儿园",
          code: "xxjd_youeryuan",
        },
        {
          sectionName: "小学",
          code: "xxjd_xiaoxue",
        },
        {
          sectionName: "初中",
          code: "xxjd_chuzhong",
        },
        {
          sectionName: "高中",
          code: "xxjd_gaozhong",
        },
        {
          sectionName: "职高",
          code: "xxjd_zhigao",
        },
      ],
      showSchoolList: [],
      /* 库类 */
      BMapGL: null, // 地图类
      point: null,
      /* 实例 */
      map: null, // 地图实例
      view: null, // 图层管理实例（覆盖物）
      bd: null, // 行政区查询实例
      /* 地图数据 */
      mapFilterData: null, // 地图搜索、分类筛选数据
      lng: 108.993459,
      lat: 34.217057,
      gxLng: 108.876443,
      gxLat: 34.21054,
      qjLng: 108.990936,
      qjLat: 34.196614,
      ytLng: 108.928271,
      ytLat: 34.190186,
      keyword: "",
      defaultAnchor: null,
      defaultOffset: null,
      markList: [],
      newMarkList: [],
      schoolList: [],
      MapVGL: null,
      THREE: null,
      textSize: 14,
      ytMapText: null,
      gxMapText: null,
      qjMapText: null,
      timer: null,
      label: [],
      textStyle: {},
      textList: [],
      viewNum: 0,
      totalStastic: {},
      sectionStatistic: {},
    };
  },
  components: { noData },
  mounted() {
    this.createMapScript();
    this.statistic();
    this.insert();
    this.statisticByStep();
  },
  computed: {
    userInfo() {
      return JSON.parse(window.sessionStorage.getItem("ssop_user_info"));
    },
    computedLeftStyle() {
      let style = {};
      let clientWidth = document.documentElement.clientWidth;
      let left = (clientWidth - 1200) / 2;
      style.left = left + "px";
      // style.left = left/12+"rem";
      return style;
    },
  },
  methods: {
    // 按学段统计总数
    statisticByStep() {
      statisticByStep({
        areaCode: 610113,
        schoolStepCode: this.activeSection.code,
      }).then((res) => {
        if (res.result) {
          this.sectionStatistic = res.result;
        }
      });
    },
    // 浏览量+1
    insert() {
      insert({
        accessUrl: window.location.href,
        userId: this.userInfo ? this.userInfo.userId : null,
      }).then((res) => {
        this.count();
      });
    },
    // 获取浏览量
    count() {
      count({
        accessUrl: window.location.href,
        // cycleType:"ALL",
        userId: this.userInfo ? this.userInfo.userId : null,
      }).then((res) => {
        if (res.result) {
          this.viewNum = res.result;
        }
      });
    },
    // 统计总数
    statistic() {
      statistic({
        areaCode: 610113,
      }).then((res) => {
        if (res.result) {
          this.totalStastic = res.result;
        }
      });
    },
    // 关键字查询
    querySearch(queryString) {
      var restaurants = this.schoolList;
      var results = queryString
        ? this.createFilter(restaurants, queryString)
        : restaurants;
      results.forEach((el) => (el.value = el.schoolName));
      this.showSchoolList = results;
      this.removeOverlay();
      this.map.closeInfoWindow();
      this.showSchoolList.forEach((el) => this.addMark(el, newIcon));
      // 调用 callback 返回建议列表的数据
      //   cb(results);
    },
    createFilter(restaurants, queryString) {
      let arr = [];
      arr = restaurants.filter(
        (restaurant) => restaurant.schoolName.indexOf(queryString) !== -1
      );
      return arr;
    },
    // 关键字选择学校
    handleSelect(n) {
      // this.removeOverlay();
      this.addMark(n, newIcon, "highLight");
    },
    // 选择学段
    sectionChange(code) {
      this.activeSection = code;
      this.map.closeInfoWindow();
      this.keyword = "";
      this.statisticByStep();
      this.getSchoolPage();
    },
    // 创建百度地图api
    async createMapScript() {
      if (!this.BMapGL) this.BMapGL = await createMap();
      if (!this.bd) this.bd = new this.BMapGL.Boundary();

      // 初始化地图配置
      const mapDefaultConfig = {
        center: [this.lng, this.lat],
        zoom: 13,
        heading: 0,
      };
      if (!this.MapVGL) {
        const mapvgl = await (() => import("mapvgl"))();
        const mapvglThree = await (() =>
          import("mapvgl/dist/mapvgl.threelayers.min"))();
        this.MapVGL = Object.assign(mapvgl, mapvglThree);

        this.THREE = this.MapVGL.THREE;
      }
      // 初始化地图
      if (!this.map) {
        this.map = initMap(this.BMapGL, mapDefaultConfig);
      }
      this.map.setDisplayOptions({
        poi: true, //是否显示POI信息
      });
      this.point = new this.BMapGL.Point(this.lng, this.lat);
      this.map.centerAndZoom(this.point, 18); //设初始化地图
      let clientWidth = document.documentElement.clientWidth;
      let scale = clientWidth <= 1466 ? 13 : 13.3;
      this.map.setZoom(scale); //设置初始缩放大小
      this.map.setTilt(40); //倾斜角度
      this.map.enableScrollWheelZoom();
      this.map.setMapStyleV2({ styleJson: styleJson });
      // 绘制3D覆盖层
      this.draw3DView();
      // 增加边线
      this.addLine();
      // 绘制雁塔区镂空层
      this.addView();
    },
    // 增加镂空覆盖层
    addView() {
      var bd = new this.BMapGL.Boundary();
      let _this = this;
      bd.get("雁塔区", function (rs) {
        var hole = new _this.BMapGL.Polygon(rs.boundaries, {
          fillColor: "#ffffff",
          fillOpacity: 0.5,
          strokeColor: "#ffffff",
        });
        _this.map.addOverlay(hole);
      });
      this.textStyle = {
        color: "#B92634",
        opacity: 0.8,
        border: "none",
        backgroundColor: "transport",
        padding: "10px",
        fontSize: this.textSize + "px",
        letterSpacing: this.textSize / 4 + "px",
        textAlign: "center",
      };
      this.otherTextStyle = {
        color: "#B92634",
        opacity: 1,
        border: "none",
        backgroundColor: "transport",
        padding: "10px",
        fontSize: this.textSize + "px",
        textAlign: "center",
      };
      this.addLabel(
        "西安高新技术产业开发区",
        this.gxLng,
        this.gxLat,
        this.textSize,
        this.otherTextStyle,
        "center"
      );
      this.addLabel(
        "曲江新区",
        this.qjLng,
        this.qjLat,
        this.textSize,
        this.otherTextStyle,
        "center"
      );
      setTimeout(() => {
        this.map.addEventListener("zoomend", this.zoomHandler);
      }, 1000);
    },
    // 绘制边线
    addLine() {
      if (!this.view) {
        this.view = new this.MapVGL.View({
          map: this.map,
        });
      }
      let points = mapData1.mapData.split(";");
      var path = [];
      for (var j = 0; j < points.length; j++) {
        var lng = points[j].split(",")[0];
        var lat = points[j].split(",")[1];
        path.push(new this.BMapGL.Point(lng, lat));
      }
      let pathHeight = 800;

      const polygonTop = path.map((item) => [
        ...this.map.lnglatToMercator(item.lng, item.lat),
        pathHeight,
      ]);
      const polygonTops = [];
      polygonTops.push({
        geometry: {
          type: "Polygon",
          coordinates: [polygonTop],
        },
        properties: {
          height: 0,
        },
        // _mark: areaItem.mark,
      });
      const shapeLayer = new this.MapVGL.LineLayer({
        color: "rgba(255,255,255,0.5)",
        blend: "lighter",
        width: 1,
        dashArray: [5, 5],
      });
      shapeLayer.setData(polygonTops);
      this.view.addLayer(shapeLayer);
    },
    //3D菱柱绘制
    draw3DView() {
      var path = [];
      let points = mapData1.mapData.split(";");
      for (var j = 0; j < points.length; j++) {
        var lng = points[j].split(",")[0];
        var lat = points[j].split(",")[1];
        path.push(new this.BMapGL.Point(lng, lat));
      }
      var prism = new this.BMapGL.Prism(path, 800, {
        topFillColor: "#0064FC",
        topFillOpacity: 0.1,
        sideFillColor: "#68B0FC",
        sideFillOpacity: 0.6,
      });
      this.map.addOverlay(prism);
      this.getSchoolPage();
      this.textStyle = {
        color: "white",
        opacity: 0.8,
        border: "none",
        backgroundColor: "transport",
        padding: "10px",
        fontSize: this.textSize + "px",
        letterSpacing: this.textSize / 4 + "px",
        textAlign: "center",
      };
    },
    // 地图放大缩小
    zoomHandler(r) {
      if (this.qjMapText || this.gxMapText) {
        let zoom = this.map.getZoom();
        if (zoom > 13.5) {
          this.textSize = (zoom - 13) * 15 + 14;
        } else if (zoom <= 13.5 && zoom > 12) {
          this.textSize = 14;
        } else {
          this.textSize = 0;
        }
        this.gxMapText.remove();
        this.qjMapText.remove();
        this.otherTextStyle = {
          color: "#B92634",
          opacity: 1,
          border: "none",
          backgroundColor: "transport",
          padding: "10px",
          fontSize: this.textSize + "px",
          textAlign: "center",
        };
        this.addLabel(
          "西安高新技术产业开发区",
          this.gxLng,
          this.gxLat,
          this.textSize,
          this.otherTextStyle,
          "center"
        );
        this.addLabel(
          "曲江新区",
          this.qjLng,
          this.qjLat,
          this.textSize,
          this.otherTextStyle,
          "center"
        );
      }
    },
    // 获取学校列表
    getSchoolPage(v) {
      this.removeOverlay();
      let params = {
        pageNo: 1,
        pageSize: 1000,
        schoolStepCode: this.activeSection.code,
        schoolName: this.keyword,
        schoolArea: "610113", //雁塔区编码
      };
      schoolPage(params).then((res) => {
        if (res.result) {
          this.schoolList = res.result.list;
          this.showSchoolList = this.schoolList;
          this.showSchoolList.forEach((el) => this.addMark(el, newIcon));
        }
      });
    },
    // 清除覆盖物
    removeOverlay() {
      if (this.markList.length > 0) {
        this.markList.forEach((el) => el.remove());
      }
    },
    // 增加图标
    addMark(item, iconType, isHighLight) {
      let lng = item.longitudeAndLatitude.split(",")[0];
      let lat = item.longitudeAndLatitude.split(",")[1];
      const point = this.map.lnglatToMercator(lng, lat);
      let markerWidth = 33;
      let markerHeight = 68;
      if (lng && lat) {
        // 创建自定义图标
        var myIcon = new this.BMapGL.Icon(
          iconType,
          new BMapGL.Size(markerWidth, markerHeight),
          {
            imageSize: new this.BMapGL.Size(markerWidth, markerHeight),
          }
        );
        // 创建点标记
        var marker = new this.BMapGL.Marker(new BMapGL.Point(lng, lat), {
          icon: myIcon,
        });
        this.markList.push(marker);
        // 在地图上添加点标记
        this.map.addOverlay(marker);
        // 创建信息窗口
        let targetUrl = `${window.ENV_API.SCHOOL_DRAW_URL}?nav=false&XXMC=${encodeURI(
          item.schoolName
        )}`;
        var opts = {
          width: 167,
          height: 90,
          title: `<a ontouchend="window.open('${targetUrl}')" href='${window.ENV_API.SCHOOL_DRAW_URL}?nav=false&XXMC=${encodeURI(
            item.schoolName
          )}' target='_blank'><div style='max-width:180px' title='${
            item.schoolName
          }'>${item.schoolName}</div>
          </a>`,
        };
        let html = "";
        var infoWindow = new this.BMapGL.InfoWindow(html, opts);
        let _this = this;
        // 选择学校高亮
        if (isHighLight) {
          _this.addInfo(item, infoWindow, marker, lng, lat);
        }
        // 点标记添加点击事件
        marker.addEventListener("click", function () {
          _this.addInfo(item, infoWindow, marker, lng, lat);
        });
        // 点标记添加点击事件
        marker.addEventListener("mouseover", function () {
          let hoverStyle = {
            color: "#555555",
            backgroundColor: "white",
            borderRadius: "5px",
            // opacity: 0.8,
            border: "none",
            // backgroundColor: "transport",
            padding: "10px",
            fontSize: "14px",
            textAlign: "center",
          };
          _this.addLabel(item.schoolName, lng, lat, 14, hoverStyle, "isHover");
        });
        marker.addEventListener("mouseout", function () {
          _this.map.removeOverlay(_this.label);
        });
        infoWindow.addEventListener("close", function (type, target, point) {
          //窗口打开是，隐藏自带的关闭按钮
          // _this.resetIcon(marker, markerSize, iconType);
          // _this.removeOverlay();
          // _this.showSchoolList.forEach((el) => _this.addMark(el, newIcon));
        });
      }
    },
    // 标记增加文字
    addLabel(name, lng, lat, fontSize, style, flag) {
      var opts = {
        position: new this.BMapGL.Point(lng, lat), // 指定文本标注所在的地理位置
        offset: new this.BMapGL.Size(
          flag === "center"
            ? -((name.length * fontSize) / 1.3)
            : -((name.length * fontSize) / 1.8), //左右
          flag === "center" ? -(fontSize + 30) : -(fontSize + 35) //上下
        ), // 设置文本偏移量
      };
      if (flag === "isHover") {
        // 创建文本标注对象
        this.label = new BMapGL.Label(name, opts);
        // 自定义文本标注样式
        this.label.setStyle(style);
        this.map.addOverlay(this.label);
      } else if (flag === "center") {
        let mapText = null;
        if (name === "西安高新技术产业开发区") {
          this.gxMapText = new BMapGL.Label(name, opts);
          mapText = this.gxMapText;
        } else {
          this.qjMapText = new BMapGL.Label(name, opts);
          mapText = this.qjMapText;
        }
        // 创建文本标注对象
        style.fontSize = fontSize + "px";
        // 自定义文本标注样式
        mapText.setStyle(style);
        this.map.addOverlay(mapText);
      } else {
        let text = new BMapGL.Label(name, opts);
        // 自定义文本标注样式
        text.setStyle(style);
        this.textList.push(text);
        this.map.addOverlay(text);
      }
    },
    // 返回原来的图标
    resetIcon(marker, markerSize, iconType) {
      let oldIcon = new this.BMapGL.Icon(
        iconType,
        new this.BMapGL.Size(30, 38),
        {
          imageSize: new this.BMapGL.Size(30, 38),
        }
      );
      marker.setIcon(oldIcon);
    },
    // 增加信息窗口
    addInfo(item, infoWindow, marker, lng, lat) {
      let studentNums = 0,
        teacherNums = 0,
        clickMarkerSize = 25;
      statisticBySchool({
        schoolId: item.schoolId,
      }).then((res) => {
        if (res.result) {
          studentNums = res.result.studentNum;
          teacherNums = res.result.teacherNum;
          infoWindow.content = `<div class='kind-name'>${item.schoolKindName}</div><div class='total'><span class='total-label' style='width:65px'>在校学生数</span><span class='total-nums'>${studentNums}人</span></div><div class='total'><span class='total-label' style='width:65px'>教职工数</span><span class='total-nums'>${teacherNums}人</span></div>`;
          // 设置新的地图图标
          // let lightMyIcon = new this.BMapGL.Icon(
          //   clickIcon,
          //   new this.BMapGL.Size(clickMarkerSize, clickMarkerSize),
          //   {
          //     imageSize: new this.BMapGL.Size(clickMarkerSize, clickMarkerSize),
          //   }
          // );
          // // 使用setIcon
          // marker.setIcon(lightMyIcon);
          this.map.openInfoWindow(infoWindow, new BMapGL.Point(lng, lat)); // 开启信息窗口
        }
      });
    },
  },
  beforeDestroy() {
    // 销毁地图及相关可视化图层管理容器
    if (this.map) this.map.destroy();
    if (this.view) this.view.destroy();
  },
};
</script>

<style lang="scss" scoped>
.map {
  margin-top:70px;
  .map-wrap {
    height: 752px;
    // padding-bottom: 40px;
    // background-color: #faf2e8;
    overflow: hidden;
    .map-content {
      height: 100%;
      background-color: #ffffff;
      position: relative;
      z-index: 2;
      display: flex;
      &::before {
        position: absolute;
        content: "";
        width: 543px;
        height: 592px;
        left: -181px;
        top: 78px;
        background: url("../../assets/images/ytHome/item-bg.png") no-repeat
          center;
        background-size: 100%;
        z-index: 1;
      }
      &::after {
        position: absolute;
        content: "";
        width: 543px;
        height: 592px;
        right: -181px;
        top: 78px;
        background: url("../../assets/images/ytHome/item-bg.png") no-repeat
          center;
        background-size: 100%;
        z-index: 1;
      }
      .map-r {
        flex: 1;
        height: 100%;
        z-index: 3;
        background-color: #ffffff;
        position: relative;
        .map-header {
          position: absolute;
          top: 0px;
          width: 100%;
          height: 77px;
          z-index: 98;
          background: linear-gradient(
            #ffe6a7,
            rgba(255, 251, 246, 0.7) 60%,
            hsla(0, 0%, 100%, 0) 80%
          );
          opacity: 0.5;
        }
        #map_container {
          height: 100%;
          /deep/.BMap_bubble_pop {
            background-color: rgba(255, 255, 255, 0.9) !important;
            box-shadow: 0px 3px 6px 2px rgba(179, 204, 239, 0.5) !important;
            .BMap_bubble_top {
              .BMap_bubble_title {
                padding-top: 12px;
                padding-left: 12px;
                overflow: inherit !important;
                a {
                  div {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    word-break: break-all;
                    font-size: 14px !important;
                    color: #20252c !important;
                    font-weight: bold;
                    &:hover {
                      text-decoration: underline;
                    }
                  }
                }
              }
              .BMap_bubble_buttons {
                div:nth-child(2n) {
                  &:hover {
                    color: #663000 !important;
                  }
                }
              }
            }
            .BMap_bubble_center {
              .BMap_bubble_content {
                padding: 0px 12px;
                .kind-name {
                  margin-bottom: 6px;
                  font-size: 12px;
                  margin-top: 4px;
                }
                .total {
                  font-size: 12px;
                  .total-label {
                    display: inline-block;
                  }
                  .total-nums {
                    color: #7d3b00;
                    margin-left: 15px;
                  }
                }
              }
            }
            // padding: 16px 18px !important;
            border: none !important;
          }
        }
        .div-r {
          width: 300px;
          height: 530px;
          z-index: 222;
          background: rgba(255, 255, 255, 0.8);
          box-shadow: 0px 1px 6px 2px rgba(246, 237, 210, 0.5);
          border-radius: 4px;
          position: absolute;
          right: 60px;
          top: 90px;
          .tabs {
            padding: 10px 0px;
            text-align: center;
            .tab-item {
              display: inline-block;
              padding: 0 10px;
              height: 40px;
              line-height: 40px;
              color: #663000;
              border-radius: 4px;
              text-align: center;
              cursor: pointer;
              font-size: 16px;
            }
            .active {
              background: #740d09;
              color: #ffffff;
            }
          }
          .section-statistics {
            margin-top: 10px;
            padding: 0px 20px;
            display: flex;
            justify-content: space-between;
            .statistics-item {
              display: inline-block;
              .text {
                font-size: 16px;
                color: #333333;
                line-height: 16px;
                margin-bottom: 12px;
              }
              .nums {
                font-size: 24px;
                font-weight: bold;
                color: #740d09;
                line-height: 34px;
                display: flex;
                .num {
                  max-width: 68px;
                  font-family: d-Alternate;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  word-break: break-all;
                }
                .unit {
                  font-size: 16px;
                  font-weight: normal;
                  margin-left: 5px;
                }
              }
            }
          }
          .map-l {
            // padding: 0px 20px;
            margin-top: 10px;
            margin-bottom: 14px;
            .map-l-input {
              padding: 0px 20px;
            }
            /deep/.el-input {
              height: 38px;
              .el-input__inner {
                height: 38px;
              }
              input::-webkit-input-placeholder {
                color: #915c2c;
              }
              .el-input__suffix {
                .el-input__suffix-inner {
                  i {
                    font-size: 20px;
                    color: #915c2c;
                  }
                }
              }
            }

            .school-list {
              height: 302px;
              overflow: auto;
              margin-top: 5px;
              padding: 0px 10px 0 20px;
              margin-right: 5px;
              .school-item {
                font-size: 16px;
                color: #27231f;
                line-height: 21px;
                border-bottom: 1px dashed rgba(167, 39, 30, 0.2);
                padding-bottom: 16px;
                padding-top: 14px;
                cursor: pointer;
                &:hover{
                  color: #740d09;
                }
              }
              .no-data {
                padding-top: 70px;
              }
            }
          }
        }
        .map-box {
          width: 1200px;
          margin: 0 auto;
          background-color: rebeccapurple;
        }
        .map-statistics {
          position: absolute;
          top: 41px;
          left: 360px;
          background: rgba(255, 255, 255, 0.8);
          box-shadow: 0px 1px 6px 2px rgba(246, 237, 210, 0.5);
          border-radius: 4px;
          z-index: 99;
          .all-statistics {
            display: flex;
            height: 83px;
            justify-content: space-between;
            padding: 15px 20px;
            .title {
              margin-right: 21px;
              font-size: 16px;
              height: 57px;
              // font-weight: bold;
              padding-top: 6px;
              color: #740d09;
              line-height: 22px;
              background-image: url("../../assets/images/ytHome/statistics-bg.png");
              background-repeat: no-repeat;
              background-position-y: bottom;
              background-position-x: center;
              background-size: 80%;
              position: relative;
              &::after {
                content: "";
                width: 1px;
                background-color: #d9c6b5;
                height: 55px;
                position: absolute;
                right: -20px;
                top: 0px;
              }
            }
            .statistics-list {
              // height: 83px;
              margin-left: 20px;
              .statistics-item {
                display: inline-block;
                margin-right: 20px;

                &:last-child {
                  margin-right: 0px;
                }
                .nums {
                  font-size: 24px;
                  font-weight: bold;
                  color: #27231f;
                  font-family: d-Alternate;
                  line-height: 27px;
                  margin-bottom: 5px;
                  max-width: 100px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  word-break: break-all;
                }
                .text {
                  font-size: 16px;
                  color: #20252c;
                  line-height: 20px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.map-l {
  .el-input {
    .el-input__inner {
      border: 1px solid #663000;
    }
  }
}
</style>